import React from 'react';

import FlexIAForm from './form';
import { DialogTreeProvider } from 'views/ChatDialogTree/form/tree/context';

const FlexIAFormProvider = () => (
  <DialogTreeProvider>
    <FlexIAForm />
  </DialogTreeProvider>
);

export default FlexIAFormProvider;
